import {IconButton, ListItem, alpha, styled} from '@mui/material';

const StyledListItem = styled(ListItem)`
	&:not(:first-child) {
		padding-top: 16px;
	}

	&:not(:last-child) {
		padding-bottom: 16px;
	}

	&:last-child {
		border-bottom: none;
	}
`;

const StyledIconButton = styled(IconButton)`
	background-color: ${({theme, color}) =>
		alpha(
			color === 'primary' ? theme.palette.primary.main : theme.palette.action.active,
			0.08,
		)};
`;

export {StyledIconButton, StyledListItem};
